import $ from 'jquery';
import React from 'react';
import isEqual from 'lodash.isequal';

import Loader from '../loader/Loader';
import FilteredListing from './FilteredListing';

import scrollTo from 'utils/scroll-to';

import createHistory from 'history/createBrowserHistory';
import { initActiveFilters, manageActiveFilters, removeActiveFilterGroup } from './utils/active-filters';
import { parseQueryString, buildQueryString } from './utils/query-string';

class FilterApp extends React.Component {
    // Validate data from props
    static propTypes = {
        url: React.PropTypes.string.isRequired,
        itemType: React.PropTypes.string,
        itemContainerLayout: React.PropTypes.string
    };

    constructor(props) {
        super(props);

        this.history = createHistory();
        this.state = {
            isLoading: true,
            data: {
                filterOptions: [],
                contentData: [],
                resources: [],
                settings: {}
            },
            APIStatus: '',
            APIMessage: '',
            activeFilters: [],
            currentSort: null,
            currentPage: 0 // page 1 is 0 (array index value)
        };
    }

    componentDidMount() {
        const newState = this.state;
        const pageData = $('#api-json').html();

        // check for JSON data on the page,
        // If it exists then we're getting data from local mock json file
        if(pageData) {
            // convert the page contents to JSON format & set to state
            const jsonPageData = $.parseJSON(pageData);
            this.setData(jsonPageData, newState);

            // hide the loader if we have items from mock JSON page data
            if (jsonPageData.contentData.length > 0) {
                newState.isLoading = false;
            }

            newState.activeFilters = initActiveFilters(jsonPageData.filterOptions);

            this.prePopulateFilters(newState);

            // update the app state with new preset filter values
            this.setState(...this.state, newState);
        } else {
            // fetch data from API endpoint
            this.fetchItems(this.props.url, newState);
        }

    }

    componentWillUpdate(newProps, newState) {
        const queryParams = buildQueryString(newState);
        this.history.replace({
            pathname: window.location.pathname,
            search: queryParams
        });

        if(newState.currentPage !== this.state.currentPage) {
            scrollTo(document.body, 0, 200);
        }
    }

    setData = (data, newState) => {
        // set results & settings
        newState.data.contentData = data.contentData;
        newState.data.settings = data.settings;

        // set filters if they exist
        if (data.filterOptions && data.filterOptions.length) {
            newState.data.filterOptions = data.filterOptions;
        }

        // set resources if they exist
        if(data.resources && data.resources.length) {
            newState.data.resources = data.resources;
        }
    }

    prePopulateFilters(newState) {
        // read the url and return preset filter obj
        const presetFilters = parseQueryString(window.location.search.substring(1), this.state.activeFilters, this.state.currentPage);


        if (!isEqual(presetFilters.activeFilters, this.state.activeFilters)) {
            newState.activeFilters = presetFilters.activeFilters;
        }

        if (parseInt(presetFilters.currentPage) !== 0) {
            newState.currentPage = parseInt(presetFilters.currentPage);
        }
    }

    fetchItems = (url, newState) => {

        $.getJSON(`/api/${url}`)
            .fail((jqxhr, textStatus, error) => {
                newState.APIStatus = 'error';
                newState.APIMessage = `${textStatus}, ${error}`;
                // update the app state with api error values
                this.setState(...this.state, newState);
            })
            .done(response => {

                this.setData(response.data, newState);

                newState.isLoading = false;

                newState.activeFilters = initActiveFilters(response.data.filterOptions);

                this.prePopulateFilters(newState);

                // update the app state with api data & new preset filter values
                this.setState(...this.state, newState);
            });
    }

    resetFilters = event => {
        event.preventDefault();
        this.setState({
            activeFilters: initActiveFilters(this.state.data.filterOptions),
            currentPage: 0
        });
    }

    resetFilterGroup = groupCode => {
        this.setState({
            activeFilters: removeActiveFilterGroup(this.state.activeFilters, groupCode),
            currentPage: 0
        });
    }

    toggleFilters = (filter, value, forceClear = false) => {
        this.toggleFocus(filter);
        this.setState({
            activeFilters: manageActiveFilters(this.state.activeFilters, filter.code, value, forceClear),
            currentPage: 0
        });
    };

    changePage = pageNum => {
        this.setState({
            currentPage: pageNum
        });
    }

    updateSort = sort => {
        this.setState({
            currentSort: sort,
            currentPage: 0
        });
    }

    renderAPIErrorMessage = () => {
        if (this.state.APIStatus === 'error') {
            return (
                <p className="validation-msg">Oops, something went wrong: {this.state.APIMessage}</p>
            );
        }
    }

    toggleFocus = filter => {
        this.setState({
            focusedFilter: filter
        });
    }

    render() {
        const { contentData, filterOptions, resources, settings } = this.state.data;
        const itemContainerLayout = this.props.itemContainerLayout ? this.props.itemContainerLayout : 'tile-horizontal';
        const itemType = this.props.itemType ? this.props.itemType : 'content';
        const filterSettingsObj = {
            "showActiveFilters": settings.showActiveFilters,
            "activeFiltersLabel": settings.activeFiltersLabel,
            "keywordPlaceholderText": settings.keywordPlaceholderText,
            "keywordSearchableFields": settings.keywordSearchableFields
        };

        if (this.state.isLoading) {
            return (
                <div>
                    <Loader />
                    {this.renderAPIErrorMessage}
                </div>
            );
        } else {
            return (
                <FilteredListing
                    items = {contentData}
                    itemContainerLayout = {itemContainerLayout}
                    itemType = {itemType}

                    resources = {resources}

                    filtersLayout = "filters-top"
                    filters = {filterOptions}
                    activeFilters = {this.state.activeFilters}
                    filterSettings = {filterSettingsObj}
                    toggleFilters = {this.toggleFilters}
                    resetFilters = {this.resetFilters}
                    resetFilterGroup = { this.resetFilterGroup}
                    focusedFilter = {this.state.focusedFilter}
                    toggleFocus = {this.toggleFocus}

                    showResultCount = {settings.showResultCount}
                    sortBy = {settings.sortBy}
                    currentSort = {this.state.currentSort}
                    updateSort = {this.updateSort}

                    currentPage = {this.state.currentPage}
                    itemsPerPage = {settings.itemsPerPage}
                    changePage = {this.changePage} />
            );
        }
    }
}

export default FilterApp;



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/FilterApp.jsx
 **/